var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imageIsClicked === false)?_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt,"id":_vm.id,"data-is-clickable":""},on:{"click":_vm.onMainImageClick,"dragstart":_vm.onDragStart,"touchstart":_vm.onDragStart}}):_c('dialog',{ref:"image-dialog",on:{"click":_vm.onDialogClick,"close":_vm.onDialogClose}},[_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }